import { COLORS } from '@r1-frontend/ui-react/assets/js/constants';
import { BaseButton } from '@r1-frontend/ui-react/components/buttons/baseButton';
import DefaultPopup from '@r1-frontend/ui-react/components/popups/defaultPopup';
import TitleSelect from '@r1-frontend/ui-react/components/select/titleSelect';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';
import styled, { css } from 'styled-components';

import DetailPick from '~/static/images/icons/detail.svg';
import arrow from '~/static/images/icons/icon-arrow-card.svg';
import arrowDarkTheme from '~/static/images/icons/icon-arrow-dark-theme.svg';

const breakpoints = {
    mobile: '767px',
    sMobile: '345px',
};

export const TitleLink = styled.a`
    ${FONTS.H4};
    color: inherit;
    white-space: pre;

    @media(max-width: ${breakpoints.sMobile}) {
        ${FONTS.S};
        font-weight: bold;
    }

    ${p => p.isSmallCards && css`
        ${FONTS.MediumXS};
    `}
`;

export const PriceBlock = styled.div`
    align-items: center;
    justify-content: space-between;
    flex-wrap: nowrap;
    margin-top: 22px;
`;

export const Price = styled.div`
    position: relative;
    color: ${COLORS.black};
    display: block;
    cursor: ${props => props.isMoreOneOptions ? 'pointer' : 'auto'};

    @media(max-width: ${breakpoints.mobile}) {
        ${FONTS.S};
    }
`;

export const TextButton = styled.div`
    position: relative;
    ${FONTS.H4};
    color: ${props => props.isDarkTheme ? COLORS.white : COLORS.black};
    white-space: nowrap;

    @media (max-width: ${breakpoints.mobile}) {
        ${FONTS.H5};
    }
`;

export const OldPrice = styled.span`
    left: 0;
    top: -18px;
    color: ${COLORS.darkGrey};
    ${FONTS.XS};

    position: absolute;
    text-decoration: line-through;
`;

export const Leasing = styled.a`
    color: ${props => props.isDarkTheme ? COLORS.white : COLORS.black};
    ${FONTS.XXS};
    display: inline-block;

    &:after {
        display: ${props => props.isMoreOneOptions ? 'inline-block' : 'none'};
        content: '';
        margin-left: 4.13px;
        width: 7.75px;
        height: 4.25px;
        background: url(${ p => p.isDarkTheme ? `${arrowDarkTheme}` : `${arrow}` }) no-repeat;
        background-size: contain;
    }

    @media (max-width: ${breakpoints.mobile}) {
        position: relative;

        &:after {
            position: absolute;
            right: -8px;
            top: 50%;
            transform: translateY(-50%);
        }
    }
`;

export const Select = styled(TitleSelect)`
    position: static !important;
    display: block;
`;

export const LabelWrapper = styled.div`
    flex-wrap: nowrap;
    display: flex;
    flex-direction: row;
    width: min-content;
    gap: 4px;

    @media (max-width: ${breakpoints.mobile}) {
        flex-wrap: wrap;
    }
`;

export const DetailBlock = styled.div`
    display: flex;
    flex-direction: column;
    width: 20%;
    align-items: flex-end;
`;

export const Detail = styled.div`
    width: 24px;
    height: 24px;
    cursor: pointer;
    background: url(${DetailPick});
`;

export const Blanket = styled.div`
    bottom: 0;
    left: 0;
    top: 0;
    right: 0;
    position: fixed;
    z-index: 1;
`;

export const Popup = styled(DefaultPopup)`
    padding: 40px;
    border-radius: 16px;
    min-height: 188px;

    @media(max-width: ${breakpoints.mobile}) {
        padding: 28px;
        width: 320px;
    }
`;

export const PopupTitle = styled.p`
    ${FONTS.H3};

    @media(max-width: ${breakpoints.mobile}) {
        border-radius: 16px 16px 0 0;
        ${FONTS.H4};
    }
`;

export const PopupCloseButton = styled.button`
    position: absolute;
    right: 14px;
    top: 14px;
    padding: 0;
    border: 0;
    background: none;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;

    &:before {
        display: block;
        content: "";
        width: 12px;
        height: 12px;
        background: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTQiIHZ
          pZXdCb3g9IjAgMCAxNCAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3Z
          nIj4KPHBhdGggZD0iTTEzIDFDNy41MzI2NiA2LjQ2NzM0IDEgMTMgMSAxM00xIDFMMTMgMTMiIHN0cm9rZT0iIzV
          DNUU2MiIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9
          pbj0icm91bmQiLz4KPC9zdmc+Cg==") no-repeat;
        background-size: contain;
    }
`;

export const EquipName = styled.p`
    ${FONTS.M};
    margin-top: 4px;
    margin-bottom: 24px;

    @media(max-width: ${breakpoints.mobile}) {
        ${FONTS.S};
        line-height: 28px;
    }
`;

export const OptionButton = styled(BaseButton)`

    margin-top: 12px;
    width: 100%;

    &:first-child {
        margin-top: 0;
    }

    @media(max-width: ${breakpoints.mobile}) {
        font-size: 14px;
    }

    div {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;

        span:nth-child(2) {
            margin-left: 0;
        }
    }
`;

export const SpecOption = styled.div`
    justify-content: space-between;
    width: 100%;
    height: 20px;
    border-bottom: ${props => props.isDarkTheme ? 'none' : `0.5px dashed ${COLORS.GRAY_S}`};
`;

export const MinPriceTitle = styled.span`
    margin-bottom: 8px;
`;
